"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOrGetFavoriteProductList = void 0;
var _createProductList = require("./createProductList");
var _getFavoriteProductList = require("./getFavoriteProductList");
/* istanbul ignore file @preserve --api */

const createOrGetFavoriteProductList = async ({
  client,
  customerId
}) => {
  const productList = await (0, _getFavoriteProductList.getFavoriteProductList)({
    client,
    customerId
  });
  if (productList === null) {
    return (0, _createProductList.createProductList)({
      client,
      customerId,
      productCodes: [],
      type: 'Favorite'
    });
  }
  return productList;
};
exports.createOrGetFavoriteProductList = createOrGetFavoriteProductList;
